import * as React from 'react';
import { Create } from 'react-admin';
import { DataSetForm, Mode } from './DataSetForm';

const DataSetCreate = () => {
    return (
        <>
            <Create>
                <DataSetForm mode={Mode.Create} />
            </Create>
        </>
    );
};

export default DataSetCreate;
